<p-toast></p-toast>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div
  class="bpt-main-content-container formwrap"
  *ngIf="accessToTrainingStatusReport; else trainingStatusNotFound"
>
  <form [formGroup]="trainingStatusForm">
    <div class="row">
      <div class="column">
        <bpt-dropdown
          label="eQMS Scope(s)"
          [options]="eQMSScopeList ?? []"
          [editable]="false"
          formControlName="eQMSScopes"
          id="trainingStatusId"
          [showClear]="true"
          [showFilter]="true"
          [labelField]="labelField"
          [valueField]="valueField"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.eQMSScopes }"
        >
        </bpt-dropdown>
      </div>
      &nbsp;
      <div class="column">
        <bpt-datetime
          id="assignmentDateRange"
          label="Assignment Date Range"
          formControlName="assignmentDateRange"
          enableRange="true"
          selectionMode="range"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.assignmentDateRange }"
        ></bpt-datetime>
      </div>
      &nbsp;
      <div class="column">
        <bpt-dropdown
          label="Training Status"
          [options]="lookupData?.trainingStatuses ?? []"
          [editable]="false"
          formControlName="trainingStatus"
          id="mainTrainingStatus"
          [showClear]="true"
          [showFilter]="true"
          [labelField]="labelField"
          [valueField]="labelField"
          [multiSelect]="true"
        >
        </bpt-dropdown>
      </div>
      &nbsp;
      <div class="buttoncolumn">
        <p-button
        appPreventDoubleClick
          label="Search"
          type="search"
          id="searchTrainingStatusReport"
          class="searchButton"
          [disabled]="false"
          (debounceClick)="getTrainingStatusReport()"
        ></p-button>
      </div>
      <div class="buttoncolumn">
        <p-button
        appPreventDoubleClick
          id="exportTrainingStatusReport"
          label = "Export"
          class="searchButton"
          [disabled]="false"
          (debounceClick)="searchAndExportExcel()"
        ></p-button>
      </div>
    </div>
  </form>
  <div class="TrainingStatusPanel" *ngIf="displayAppPanel">
    <app-panel-hub
      *ngIf="isTrainingStatusReportAvailable"
      [config]="panelHubConfig"
      [pagedData]="pagedData"
      (panelHubStateChanged)="onPanelHubStateChanged($event)"
      (panelEventHub)="onPanelEventHubInitialized()"
      (exportClicked)="exportExcel()"
      class="training-status-report-panel"
    >
      <ng-template #contentTemplate let-data="dataVar">
        <div panel-content>
          <div class="grid">
            <div class="fields-row">
              <div class="clm column1">
                <app-label labelText="{{ 'User' }}"></app-label>
                <div>
                  <app-read-only [ngClass]="{'inActiveGroup':data?.isUserTerminated === true }"
                    readonlyText="{{ data?.user }}"
                  ></app-read-only>
                </div>
              </div>
              <div class="clm column2">
                <div class="mb-1">Training Item</div>
                <div *ngIf="data?.type === 'Document'">
                  <a
                    class="overflow-ellipse-link"
                    style="cursor: pointer"
                    (click)="openDocument(data?.trainingItemId, data?.version)"
                  >
                    <app-read-only
                      readonlyText="{{ data?.trainingItemId }} {{
                        data?.trainingItem
                      }} (v{{ data?.version }})"
                      toolTipMessage="{{ data?.trainingItemId }} {{
                        data?.trainingItem
                      }} (v{{ data?.version }})"
                    >
                    </app-read-only>
                  </a>
                </div>
                <div *ngIf="data?.type === 'Course'">
                  <a
                    class="overflow-ellipse-link"
                    style="cursor: pointer"
                    (click)="openCourse(data?.trainingItemId)"
                  >
                    <app-read-only
                      readonlyText="{{ data?.trainingItemId }} {{
                        data?.trainingItem
                      }}"
                      toolTipMessage="{{ data?.trainingItemId }} {{
                        data?.trainingItem
                      }}"
                    >
                    </app-read-only>
                  </a>
                </div>
              </div>
              <div class="clm column3">
                <app-label labelText="{{ 'Type' }}"></app-label>
                <app-read-only readonlyText="{{ data?.type }}"></app-read-only>
              </div>

              <div class="clm column4">
                <app-label labelText="{{ 'Training Status' }}"></app-label>
                <div class="grid pt-1 trainingOccurence-status">
                  <div class="col max-w-0 pb-0">
                    <em
                      class="pi pi-circle-fill ml-1 mr-1 mt-1"
                      [ngClass]="calculateStatusColor(data?.trainingStatus)"
                    ></em>
                  </div>
                  &nbsp;
                  <div class="col ml-2 pb-0">
                    <app-read-only
                      readonlyText="{{ data?.trainingStatus }}"
                      toolTipMessage="{{ data?.trainingStatus }}"
                    ></app-read-only>
                  </div>
                </div>
              </div>

              <div class="clm column5">
                <app-label labelText="{{ 'Core / Elective' }}"></app-label>
                <app-read-only
                  readonlyText="{{ data?.coreOrElective }}"
                  toolTipMessage="{{ data?.coreOrElective }}"
                ></app-read-only>
              </div>

              <div class="clm column6">
                <app-label labelText="{{ 'Assignment Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{
                    data?.assignmentDate | date : 'dd-MMM-yyyy'
                  }}"
                  toolTipMessage="{{
                    data?.assignmentDate | date : 'dd-MMM-yyyy'
                  }}"
                ></app-read-only>
              </div>
              <div class="clm column7">
                <app-label labelText="{{ 'Due Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{ data?.dueDate | date : 'dd-MMM-yyyy' }}"
                  toolTipMessage="{{ data?.dueDate | date : 'dd-MMM-yyyy' }}"
                ></app-read-only>
              </div>
              <div class="clm column8">
                <app-label labelText="{{ 'Complete Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{
                    data?.completedDate | date : 'dd-MMM-yyyy'
                  }}"
                  toolTipMessage="{{
                    data?.completeDate | date : 'dd-MMM-yyyy'
                  }}"
                ></app-read-only>
              </div>
              <div class="clm column9">
                <app-label labelText="{{ 'Expiration Date' }}"></app-label>
                <app-read-only
                  *ngIf="data?.type === 'Document'"
                  readonlyText="{{ data?.expirationDate }}"
                  toolTipMessage="{{ data?.expirationDate }}"
                ></app-read-only>
                <app-read-only
                  *ngIf="data?.type === 'Course'"
                  readonlyText="{{
                    data?.expirationDate | date : 'dd-MMM-yyyy'
                  }}"
                  toolTipMessage="{{
                    data?.expirationDate | date : 'dd-MMM-yyyy'
                  }}"
                ></app-read-only>
              </div>
              <div class="clm column10">
                <app-label labelText="{{ 'Removal Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{ data?.removalDate | date : 'dd-MMM-yyyy' }}"
                  toolTipMessage="{{
                    data?.removalDate | date : 'dd-MMM-yyyy'
                  }}"
                ></app-read-only>
              </div>
              <div class="clm column11">
                <app-label labelText="{{ 'Cancellation Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{
                    data?.cancellationDate | date : 'dd-MMM-yyyy'
                  }}"
                  toolTipMessage="{{
                    data?.cancellationDate | date : 'dd-MMM-yyyy'
                  }}"
                ></app-read-only>
              </div>
              <div class="clm column12">
                <app-label labelText="{{ 'Revocation  Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{
                    data?.revocationDate | date : 'dd-MMM-yyyy'
                  }}"
                  toolTipMessage="{{
                    data?.revocationDate | date : 'dd-MMM-yyyy'
                  }}"
                ></app-read-only>
              </div>
              <div class="clm column13">
                <app-label labelText="{{ 'Curriculum' }}"></app-label>
                <div class="content-wrap font-semibold">
                  <div *ngFor="let curriculum of data?.curriculum">
                    {{ curriculum }}
                  </div>
                </div>
              </div>
              <div class="clm column14">
                <app-label labelText="{{ 'Training Item Group' }}"></app-label>
                <div class="content-wrap font-semibold">
                  <div
                    *ngFor="let trainingItemGroup of data?.trainingItemGroups"
                  >
                    {{ trainingItemGroup }}
                  </div>
                </div>
              </div>
              <div class="clm column15">
                <app-label labelText="{{ 'Manager' }}"></app-label>
                <app-read-only [ngClass]="{'inActiveGroup':data?.isManagerTerminated === true }"
                  readonlyText="{{ data?.manager }}"
                  toolTipMessage="{{ data?.manager }}"
                ></app-read-only>
              </div>
              <div class="clm column16">
                <app-label labelText="{{ 'Cost Center' }}"></app-label>
                <app-read-only
                  readonlyText="{{ data?.costCenter }}"
                  toolTipMessage="{{ data?.costCenter }}"
                ></app-read-only>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </app-panel-hub>
    <app-spinner *ngIf="showLoader" [message]="SpinnerMessage"></app-spinner>
  </div>
</div>

<ng-template #trainingStatusNotFound>
  <app-error
    [errorMessage]="TrainingStatusReportAccessErrorMessage()"
  ></app-error>
</ng-template>
